export const isOnline = () => {
  if (typeof navigator === "undefined") {
    return true;
  }
  return navigator.onLine;
};
export const isOffline = () => {
  return !isOnline();
};

export const subscribeToReconnect = (callback) => {
  if (typeof window === "undefined") {
    return () => {};
  }

  let previousOnlineState = isOnline();

  const handleConnectionChange = () => {
    const currentOnlineState = isOnline();

    if (previousOnlineState === false && currentOnlineState === true) {
      callback();
    }

    previousOnlineState = currentOnlineState;
  };

  window.addEventListener("online", handleConnectionChange);
  window.addEventListener("offline", handleConnectionChange);

  return () => {
    window.removeEventListener("online", handleConnectionChange);
    window.removeEventListener("offline", handleConnectionChange);
  };
};

export const subscribeToConnectionChange = (callback) => {
  if (typeof window === "undefined") {
    return () => {};
  }

  const handler = () => {
    callback();
  };

  window.addEventListener("online", handler);
  window.addEventListener("offline", handler);

  return () => {
    window.removeEventListener("online", handler);
    window.removeEventListener("offline", handler);
  };
};
